import React from 'react';
import { MoreVertical, Trash2, Save, Copy } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';

interface ProjectCardMenuProps {
  onDelete?: () => void;
  onSaveToCms?: () => void;
  onClone?: () => void;
  className?: string;
}

export const ProjectCardMenu: React.FC<ProjectCardMenuProps> = ({
  onDelete,
  onSaveToCms,
  onClone,
  className = "",
}) => {
  return (
    <div className={className} onClick={(e) => e.stopPropagation()}>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button 
            className="p-1.5 hover:bg-black/5 rounded-full transition-colors outline-none focus:ring-1 focus:ring-primary/20"
            aria-label="More options"
          >
            <MoreVertical className="w-4 h-4 text-[#667185] hover:text-[#101928]" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-48 p-1 shadow-lg border-gray-100">
          {onClone && (
            <DropdownMenuItem
              onClick={onClone}
              className="flex items-center gap-2 px-3 py-2 cursor-pointer text-[#344054] hover:bg-gray-50 rounded-md transition-colors"
            >
              <Copy className="w-4 h-4 text-[#667185]" />
              <span className="font-sans text-[13px] font-medium" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
                Clone Template
              </span>
            </DropdownMenuItem>
          )}
          <DropdownMenuItem
            onClick={onSaveToCms}
            className="flex items-center gap-2 px-3 py-2 cursor-pointer text-[#344054] hover:bg-gray-50 rounded-md transition-colors"
          >
            <Save className="w-4 h-4 text-[#667185]" />
            <span className="font-sans text-[13px] font-medium" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
              Save to CMS
            </span>
          </DropdownMenuItem>
          <DropdownMenuItem
            onClick={onDelete}
            className="flex items-center gap-2 px-3 py-2 cursor-pointer text-[#B32318] hover:bg-red-50 focus:bg-red-50 focus:text-[#B32318] rounded-md transition-colors"
          >
            <Trash2 className="w-4 h-4 text-[#B32318]" />
            <span className="font-sans text-[13px] font-medium" style={{ fontVariationSettings: "'opsz' 14, 'wdth' 100" }}>
              Delete Project
            </span>
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
